namespace Ir.Components.User.ChangePassword {

    interface IViewModel {
        currentPasswordConfig: DevExpress.ui.dxTextBox.Properties;
        currentPasswordComponent: DevExpress.ui.dxTextBox;
        currentPasswordValidatorConfig: DevExpress.ui.dxValidator.Properties;

        newPasswordConfig: DevExpress.ui.dxTextBox.Properties;
        newPasswordComponent: DevExpress.ui.dxTextBox;
        newPasswordValidatorConfig: DevExpress.ui.dxValidator.Properties;

        confirmPasswordConfig: DevExpress.ui.dxTextBox.Properties;
        confirmPasswordComponent: DevExpress.ui.dxTextBox;
        confirmPasswordValidatorConfig: DevExpress.ui.dxValidator.Properties;

        currentPassword: KnockoutObservable<string>;
        newPassword: KnockoutObservable<string>;
        confirmPassword: KnockoutObservable<string>;
    }
    interface IParams {
    }

    let self: IViewModel = null;
    let popupComponent: DevExpress.ui.dxPopup;
    const validationGroup = "resetPasswordGroup";
    export function getViewModel(this: IViewModel, params: IParams) {
        self = this;
        
        this.currentPassword = ko.observable("");
        this.newPassword = ko.observable("");
        this.confirmPassword = ko.observable("");
        this.currentPasswordConfig = {
            value: this.currentPassword as any,
            mode: 'password',
            stylingMode: 'outlined',
            label: 'Current Password',
            labelMode:"outside",
            buttons: [{
                name: 'password',
                location: 'after',
                options: {
                    icon: 'eyeopen',
                    stylingMode: 'text',
                    onClick() {
                        changePasswordMode(self.currentPasswordComponent);
                    },
                },
            }],
            onInitialized(e) {
                self.currentPasswordComponent = e.component;
            }
        };
        this.currentPasswordValidatorConfig = {
            validationGroup: validationGroup,
            validationRules: [{
                type: 'required',
            }]
        };

        this.newPasswordConfig = {
            value: this.newPassword as any,
            mode: 'password',
            stylingMode: 'outlined',
            label: 'New Password',
            labelMode: "outside",
            buttons: [{
                name: 'password',
                location: 'after',
                options: {
                    icon: 'eyeopen',
                    stylingMode: 'text',
                    onClick() {
                        changePasswordMode(self.newPasswordComponent);
                    },
                },
            }],
            onInitialized(e) {
                self.newPasswordComponent = e.component;
            }
        };
        this.newPasswordValidatorConfig = {
            validationGroup: validationGroup,
            validationRules: [{
                type: 'required',
            }]
        };

        this.confirmPasswordConfig = {
            value: this.confirmPassword as any,
            mode: 'password',
            stylingMode: 'outlined',
            label: 'Confirm New Password',
            labelMode: "outside",
            buttons: [{
                name: 'password',
                location: 'after',
                options: {
                    icon: 'eyeopen',
                    stylingMode: 'text',
                    onClick() {
                        changePasswordMode(self.confirmPasswordComponent);
                    },
                },
            }],
            onInitialized(e) {
                self.confirmPasswordComponent = e.component;
            }
        };
        this.confirmPasswordValidatorConfig = {
            validationGroup: validationGroup,
            validationRules: [{
                type: 'required',
            }, {
                type: 'compare',
                comparisonTarget() {
                    return self.newPasswordComponent.option('value');
                },
                message: "'New Password' and 'Confirm New Password' do not match.",
            },]
        };
    }

    function changePasswordMode(component: DevExpress.ui.dxTextBox) {
        component.option('mode', component.option('mode') === 'text' ? 'password' : 'text');
    };

    function saveNewPassword() {
        let o = {
            url: `${urlConfigs.user}SaveChangePassword`,
            data: {
                password: self.currentPassword(),
                newPassword: self.newPassword(),
                confirmPassword: self.confirmPassword()
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (result) {
            if (result.success) {
                DevExpress.ui.notify('Password changed successfully');
                popupComponent.hide();
            }
            else {
                irGlobal.defaultErrorFunction("Failed to change password", result.error, "");
            }
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to change password";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    export function show() {
        if (popupComponent) {
            popupComponent.show();
        }
        else {
            let popupOptions = {
                width: 400,
                height: 240,
                showTitle: true,
                title: "Change Password",
                visible: false,
                dragEnabled: false,
                hideOnOutsideClick: false,
                showCloseButton: true,
                toolbarItems: [{
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    options: {
                        icon: 'save',
                        stylingMode: 'contained',
                        type: 'default',
                        text: 'Save',
                        onClick() {
                            let result = DevExpress.validationEngine.validateGroup(validationGroup);
                            if (result.isValid) {
                                saveNewPassword();                                
                            }
                        }
                    },
                }, {
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    options: {
                        text: 'Close',
                        icon: 'remove',
                        stylingMode: 'outlined',
                        type: 'normal',
                        onClick() {
                            popupComponent.hide();
                        }
                    },
                }],
                onInitialized(e) {
                    popupComponent = e.component;
                    popupComponent.show();
                },
                onHidden(e) {
                    DevExpress.validationEngine.resetGroup(validationGroup);
                }
            } as DevExpress.ui.dxPopover.Properties;

            let $popover = $(`
            <div data-bind="dxPopup: popupOptions">
                <user-change-password></user-change-password>
            </div>`);
            $popover.appendTo('body');

            ko.applyBindings({ popupOptions }, $popover[0]);
        }
    }
}